import { Component, OnInit } from '@angular/core';
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {PopupOrderComponent} from "../../popup-order/popup-order.component";
import {PopupTvProstoComponent} from "../../component/popup-tv-prosto/popup-tv-prosto.component";
import {PopupTvLightComponent} from "../../component/popup-tv-light/popup-tv-light.component";
import {PopupTvBaseComponent} from "../../component/popup-tv-base/popup-tv-base.component";

@Component({
  selector: 'app-tarrifs',
  templateUrl: './tarrifs.component.html',
  styleUrls: ['./tarrifs.component.scss']
})
export class TarrifsComponent implements OnInit {
  title = 'octopus';
  active = 1;
  constructor(private modalService: NgbModal) {
  }
  ngOnInit(): void {
  }
  openPopup() {
    const modalRef = this.modalService.open(PopupOrderComponent);
  }

  openPopupTV(type) {
    console.log(type);
    if (type === 'prosto') {
      const modalRef = this.modalService.open(PopupTvProstoComponent, { size: 'lg' });
    } else if (type === 'light') {
      const modalRef = this.modalService.open(PopupTvLightComponent, { size: 'lg' });
    } else {
      const modalRef = this.modalService.open(PopupTvBaseComponent, { size: 'lg' });
    }
  }

}
